import { gql } from 'graphql-tag';
import { AdProductFragment } from './adProductFragment';

export const createProductSetForPriceCheckerPreviewMutation = gql`
  mutation CreateProductSetForPriceCheckerPreview(
    $input: CreateProductSetForPriceCheckerPreviewInput!
  ) {
    createProductSetForPriceCheckerPreview(input: $input) {
      productSet {
        id
        items {
          ... on AdProduct {
            ...AdProductParts
          }
        }
      }
    }
  }
  ${AdProductFragment}
`;
